module.exports = __webpack_public_path__ + "media/images/gray-instagram-40b5bd77d2c05295ad6765f62dd97a0a.png";